import React from 'react'
import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import RowStack from 'components/atoms/container/RowStack'
import LikertScale from 'components/molecules/LikertScale'
import { ColStack } from 'components/atoms/container/InCardStack'
import { AssessmentLikertScale } from 'components/molecules/assessments/AssessmentMolecules'

const QuestionRow = ({
  questionText,
  order,
  initialValue,
  onChange,
  options,
  colStyle = false
}) => {
  return (
    <>
      {colStyle ? (
        <ColStack spacing={12}>
          <RowStack spacing={4} alignItems='flex-start'>
            <Typography fontWeight='600'>{order}.</Typography>
            <Typography variant='bodyLarge'>{questionText}</Typography>
          </RowStack>
          
          <AssessmentLikertScale
            id={order}
            onChange={onChange}
            initialValue={initialValue}
            options={options}
          />
        </ColStack>
      ) : (
        <Grid container columnSpacing={28} width={'100%'}>
          <Grid
            size={{ md: 12, lg: 6 }}
            sx={{ display: 'flex', alignItems: 'center' }}>
            <RowStack
              spacing={4}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
              <Typography
                sx={{ alignSelf: 'flex-start' }}
                variant='body1Large'
                fontWeight='bold'>
                {order}.
              </Typography>
              <Typography variant='bodyLarge'>{questionText}</Typography>
            </RowStack>
          </Grid>
          <Grid size={{ md: 12, lg: 6 }}>
            <LikertScale
              id={order}
              onChange={onChange}
              initialValue={initialValue}
              options={options}
            />
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default QuestionRow
